const inputTextSizes: string[] = ['8', '9', '10', '14', '15', '16', '17', '18', '19', '24', '50']

export default inputTextSizes
